import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Contact from "../pages/Contact";

const Router = () => {

    const [headerData, setHeaderData] = useState([]);

    return (
        <BrowserRouter>

            <Header />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="*" element={<Home />} />

            </Routes>
            <Footer headerData={headerData} />
        </BrowserRouter >


    )
}
export default Router;